import React from 'react';
import styled from 'styled-components';
import dn from '../../assets/dn.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import ReactCompareImage from 'react-compare-image';
import before from '../../assets/shell01.jpg';
import after from '../../assets/shell02.jpg';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  
  @media (max-width: 768px) {
    width: 100%;

  }
`;

const Viz = styled.div`
  display: flex;
  width: 100%;

  justify-content: flex-start;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
`;


class CardAcidification extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
      <ReactCompareImage leftImage={before} rightImage={after} />;

    </Viz>

   <ReusableDetailCard
   trend= {dn}
   metricsm="pH: 8.1"
   diagnosis="As the ocean continues to absorb more CO2, the pH decreases and the ocean becomes more acidic. This reduces the amount of carbonate, a key building block in seawater for marine organisms."
   prediction="Changes in marine ecosystems will have consequences for human societies, which depend on the goods and services these ecosystems provide."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
</Container>


  );
 }
}
export default CardAcidification;
